import { render } from "./WelcomeHome.vue?vue&type=template&id=97d6e798"
import script from "./WelcomeHome.vue?vue&type=script&lang=js"
export * from "./WelcomeHome.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__